/**
 * 此处把核心框架的默认配置文件合并,并且合并编译后的配置
 */
 IDM.mix(true,IDM.setting, (window.$$IDMSetting ? window.$$IDMSetting : {}))
